const ITEMS = [
  "Frâne & Plăcuțe",
  "Iluminat LED & Xenon",
  "Suspensii & Amortizoare",
  "Uleiuri & Lichide",
  "Filtre Premium",
  "Baterii Auto 12V",
  "Piese Timișoara",
  "Comenzi la Telefon",
  "Consultanță după VIN",
  "Piese și pe Comandă",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="editorial-marquee" className="relative border-y border-white/10 bg-[#0A1A38] py-5 overflow-hidden">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-lg sm:text-xl font-bold uppercase tracking-[0.12em] text-slate-600 px-6">
                  {item}
                </span>
                <span className={`h-1.5 w-1.5 rotate-45 ${i % 2 === 0 ? "bg-[#0055FF]/50" : "bg-[#FF2A3B]/50"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
